export default __webpack_public_path__ + "static/media/11t.a08a4f30.jpg";